/* eslint import/no-webpack-loader-syntax: off */
import css from "!!raw-loader!./pointer.css";
/* eslint import/no-webpack-loader-syntax: off */
import html from "!!raw-loader!./core.html";
const pointer = { id: "coreOnly", css, defaultCore: html };
export default pointer;
